import { CHANGE_PRESENTATION_TASK_USER_EVENT } from '@/content/values/ed-presentation-mode.values';
import { SECTION_TYPES } from '@/content/values/sections';
import { IRequestHomeworkBySectionStudent } from '@/homework/interfaces/request-homework-by-section-student.interface';
import { HOMEWORKS_STORE } from '@/homework/store/homeworks.store';
import Component from 'vue-class-component';
import KEYS from '@/values/keys';
import { Mixins } from 'vue-property-decorator';
import EdPresentationModeMixin from '@/content/mixins/ed-presentation-mode.mixin';
import { MEETINGS_STORE } from '@/meetings/store/meetings.store';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';

@Component({})
export default class EdPresentationModeTask extends Mixins(EdPresentationModeMixin) {

  public params : any = null;
  public isLoading : boolean = true;

  get currentBoardUserId() : number {
    return this.$store.state.MeetingsStore.currentBoardUser.id;
  }

  get isPresentationModeStudent(){
    return this.$store.state.CourseStore.isPresentationStudentMode;
  }

  get isPresentationTeacherMode(){
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get isPresentationModeGuestTeacher() : boolean {
    return this.$store.state.MeetingsStore.isPresentationModeGuestTeacher;
  }

  private getPersonInfo() : void {
    if(!this.currentBoardUserId){
      return;
    }

    if(this.isPresentationModeGuestTeacher && this.user.id === this.currentBoardUserId){
      this.upadateDefaultTeacher();
      return;
    }

    this.isLoading = true;
    let request : IRequestHomeworkBySectionStudent = {
      classId: this.currentPresentationSection.classId,
      contentId: this.currentPresentationSection.courseId,
      sectionId: this.currentPresentationSection.sectionId,
      studentId: this.currentBoardUserId
    };
    
    this.$store.dispatch(HOMEWORKS_STORE.ACTIONS.OBTAIN_SECTION_HOMEWORK, request)
    .then(() => {
      if(!this.presentationSectionSelected){
        return;
      }
      if(!this.validateCanOpenWithCurrentVersion() && this.isPresentationModeStudent){
        this.upadateDefaultTeacher();
        return;
      }
      this.params = this.obtainDraftResponseParams(this.presentationSectionSelected);
      this.showSectionExpirationTask();
      this.isLoading = false;
    }).catch(() => {
      this.$EdModal.createMessageModal({
        title: this.$t('common.error'),
        body: this.$t('errors.load'),
        type: KEYS.EVENT_TYPES.DANGER
      });
    });
  }

  private showSectionExpirationTask(){
    if(this.presentationSectionSelected.expiration){
      this.$EdToast.create({
        msg: `${this.$t('errors.expirationHomework')}`,
        type: TOAST_TYPES.WARNING,
        top: '3rem',
        timeout: 3000
      });
    }
  }

  private obtainDraftResponseParams(section : any): any {
    return {
      section : {
        ...section.responseDraft,
        assetsInfo: section.response && section.response.homeworkAssetInfo
                    ? [section.response.homeworkAssetInfo] : section.section.assetsInfo
                    ? section.section.assetsInfo : null,
        section: section.section,
        type: section.section.type,
        text: section.section.text,
        sectionId: section.section.sectionId,
        classId: section.classId,
        studentId: section.student.id,
        sections: section.section.sections,
        sectionMaterial: section.section.sectionMaterial,
      },
      student: section.student,
      canResponse: !section.response,
      responseDraft: section.responseDraft ? section.responseDraft : null,
      response: section.response ? section.response : null,
      viewer: SECTION_TYPES[section.section.type].viewerHomework,
      courseId: this.currentPresentationSection.courseId
    };
  }

  private upadateDefaultTeacher() : void {
    this.$store.commit(HOMEWORKS_STORE.MUTATIONS.UPDATE_HOMEWORK_SECTION_IS_SENT, {sectionId: this.currentPresentationSection.sectionId, isSent: true});
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_BOARD_USER, {
      isTeacher: true,
      sectionId: this.currentPresentationSection.sectionId,
      fullName: this.$t('myContent.teacher')
    });
    this.$store.commit(HOMEWORKS_STORE.MUTATIONS.CLEAR_PRESENTATION_SECTION_CONTENT);
  }

  private validateCanOpenWithCurrentVersion() : boolean {
    if(!this.canOpenWithCurrentVersion){
      this.$EdToast.create({ 
        msg:  `${this.$t('homeworks.cantOpenHomework')}`,
        type: TOAST_TYPES.WARNING,
        top: '3rem',
        timeout: 5000
      });
    }
    return this.canOpenWithCurrentVersion;
  }
  
  mounted() {
    this.$edEventBus.$on(CHANGE_PRESENTATION_TASK_USER_EVENT, this.getPersonInfo);
    if(this.currentBoardUserId === this.userLoginId && this.isPresentationModeStudent){
      this.getPersonInfo();
    }
    
    if(this.currentBoardUserId !== this.userLoginId && this.isPresentationTeacherMode){
      this.getPersonInfo();
    } 
  }

  beforeDestroy() {
    this.$edEventBus.$off(CHANGE_PRESENTATION_TASK_USER_EVENT);
  }
}